@if (appState$ | async; as appState) {
  <!--Loader division-->
  @if (appState.isAuthInProgress) {
    <div class="d-flex justify-content-center align-items-center h-100 min-vh-100">
      <div class="spinner-border spinner-border-sm" role="status" id="authLoginProgressSpinner">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  }

  <!--Header division-->
  @if (appState.showHeader) {
    <div id="app-header">
      <app-header [hideSettings]="hideNavigationSubject"></app-header>
    </div>
  }

  <!--Router outlet (display routes as per configuration in routing.module)-->
  @if (appState.showContent) {
    <div id="app-content" [ngClass]="appState.hideNavigation ? 'h-100 pt-0' : ''">
      <div class="mh-section-content" [ngClass]="{ 'h-100 w-100': appState.hideNavigation }">
        <router-outlet></router-outlet>
      </div>
    </div>
  }

  <!--Footer division-->
  @if (appState.showFooter) {
    <div class="mt-auto w-100">
      @defer (on viewport) {
        <app-footer></app-footer>
      } @placeholder {
        <div class="text-center p-3">
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden">Loading footer...</span>
          </div>
        </div>
      }
    </div>
  }
}
